export default "__VITE_ASSET__d219a7e3__"